import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=9a6db868&scoped=true"
import script from "./user-manage.vue?vue&type=script&lang=js"
export * from "./user-manage.vue?vue&type=script&lang=js"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=9a6db868&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6db868",
  null
  
)

export default component.exports